'use client';

import dynamic from 'next/dynamic';

export const Zoovu = dynamic(
  () => import(/* webpackChunkName: 'Zoovu' */ './Zoovu.client').then((mod) => mod.Zoovu),
  {
    ssr: false,
  },
);
